import { Grid, Typography } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import React, { useEffect, useState } from "react";
import { getUser, getUserId } from "../Utils/Common";
import Home from "./Home";
import { Col, Row } from "react-bootstrap";
import BillingReportsService from "../../Services/Reports/BillingReportsService";
import OperationReportService from "../../Services/Reports/OperationReportService";

export const useDate = () => {
  const locale = "en";
  const [today, setDate] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setDate(new Date()), 10000);
    return () => clearInterval(timer);
  }, []);

  const day = today.toLocaleDateString(locale, { weekday: "short" });
  const date = `${day}, ${today.getDate()} ${today.toLocaleDateString(locale, {
    month: "short",
  })}`;

  const hour = today.getHours();
  const wish = `Good ${
    hour < 12 ? "Morning" : hour < 15 ? "Afternoon" : "Evening"
  }`;

  const time = today.toLocaleTimeString(locale, {
    hour: "numeric",
    hour12: true,
    minute: "numeric",
    second: "numeric",
  });

  return { date, time, wish };
};

function DashBoard() {
  const [values, setvalues] = useState(0);
  const [values2, setvalues2] = useState(0);
  const [values3, setvalues3] = useState(0);
  const [values4, setvalues4] = useState(0);

  const [amount, setamount] = useState({
    totaljobamt: 0,
    totalvendoramt: 0,
    totalmiscamt: 0,
  });

  const { wish } = useDate();
  const month = new Date().toLocaleString("default", { month: "long" });

  const arrowicon = () => <ArrowForwardIosIcon />;

  const getDashboardData = (type, callback, fallback = 0) => {
    BillingReportsService.getDashboardDetails(getUserId(), type).then((res) => {
      const data = res.data;
      if (Array.isArray(data) && data.length > 0) {
        callback(data[0]);
      } else {
        console.warn(`No data returned for type ${type}`);
        callback({ value: fallback });
      }
    });
  };

  const gettotalimportjobs = () =>
    getDashboardData(1, (d) => setvalues(d.total_import_jobs ?? 0));
  const gettotalexportjobs = () =>
    getDashboardData(2, (d) => setvalues2(d.total_export_jobs ?? 0));
  const gettotalbilledjobs = () =>
    getDashboardData(3, (d) => setvalues3(d.total_billed_jobs ?? 0));
  const gettotalunbilledjobs = () =>
    getDashboardData(8, (d) => setvalues4(d.total_non_billed_jobs ?? 0));

  const getamt = () =>
    getDashboardData(4, (d) =>
      setamount({
        totaljobamt: d.job_amt ?? 0,
        totalvendoramt: d.vendor_amt ?? 0,
        totalmiscamt: d.misc_amt ?? 0,
      })
    );

  useEffect(() => {
    gettotalimportjobs();
    gettotalexportjobs();
    gettotalbilledjobs();
    gettotalunbilledjobs();
    getamt();
  }, []);

  const openLink = (url) => window.open(url, "_blank");

  const importjob = () => openLink("http://35.154.221.117:8081/Ngp_Imports/");
  const ExportJob = () =>
    openLink("http://35.154.27.147:8080/ngpillai_export/");

  const getDashboardReport = (val) => {
    BillingReportsService.getdashboardReport(getUserId(), val).then((res) => {
      const data = res.data;

      if (!data || !data.length) {
        alert("No data available for Excel export.");
        return;
      }

      let tableContent2 = "";
      data.forEach((d) => {
        const fields = [
          d.payments_id,
          d.fund_request_type,
          d.consignmentIds,
          d.request_purpose,
          d.request_amount,
          d.approval_amount,
          d.first_level_amount,
          d.second_level_amount,
          d.allocated_amount,
          d.release_amount,
          d.release_mode,
          d.audit_amount,
          d.request_date,
          d.approval_date,
          d.first_level_date,
          d.second_level_date,
          d.allocated_date,
          d.release_date,
          d.audit_date,
          d.request_remarks,
          d.approval_remarks,
          d.first_level_remarks,
          d.second_level_remarks,
          d.allocated_remarks,
          d.release_remarks,
          d.audit_remarks,
          d.req_by,
          d.approved_by,
          d.first_level_by,
          d.second_level_by,
          d.allocated_by,
          d.released_by,
          d.audit_by,
          d.status,
        ];
        tableContent2 += fields.map((f) => f || "").join("!") + "#";
      });

      const details = {
        headerName2: "3,0,ACCOUNT DETAILS REPORT",
        tableHeader2:
          "0,3,Sl.No/1,3,Payments_id/2,3,Fund Request Type/3,3,consignmentId/4,3,Request Purpose/5,3,Request Amount/6,3,Approval Amount/7,3,Firstlevel Amount/8,3,SecondLevel Amount/9,3,Allocated_amount/10,3,Release Amount/11,3,Release Mode/12,3,Audit Amount/13,3,Request Date/14,3,Approval Date/15,3,First_level_date/16,3,Second_level_date/17,3,Allocated_date/18,3,Release_date/19,3,Audit_date/20,3,Request_remarks/21,3,Approval_remarks/22,3,First_level_remarks/23,3,Second_level_remarks/24,3,Allocated_remarks/25,3,Release_remarks/26,3,Audit_remarks/27,3,Req_by/28,3,Approved_by/29,3,First_level_b/30,3,Second_level_by/31,3,Allocated_by/32,3,Released_by/33,3,Audit_by/34,3,Status",
        tableRowStartsFrom2: 4,
        tableColumnStartsFrom2: 0,
        fileCode2: "BillDep",
        totalNumberOfColumn2: 35,
        tableContent2: tableContent2.slice(0, -1),
      };

      OperationReportService.AccountExcelwriteDash(details).then((res) => {
        const filename = res.data.message;
        openLink(`http://35.154.221.117:8081/ExportFiles/${filename}`);
      });
    });
  };

  const exceljob = () => getDashboardReport(5);
  const excelmisc = () => getDashboardReport(6);
  const excelvendor = () => getDashboardReport(7);

  return (
    <div>
      <Home />
      <Grid className="container" style={{ paddingLeft: "50px" }}>
        <Row style={{ marginBottom: "70px" }}>
          <Row>
            <Typography
              className="mt-5"
              style={{
                fontFamily: "Times New Roman",
                fontWeight: "bold",
                fontSize: "25px",
              }}
            >
              Home/Dashboard
              <span className="wishcss">
                {wish} {getUser()}
              </span>
            </Typography>

            {/* CARD BLOCKS */}
            <Col className="mt-1">
              <div className="card cardclr1 mb-3" style={{ height: "9rem" }}>
                <div className="card-body ">
                  <label className="dshHeader">
                    <span style={{ fontSize: "15px", marginRight: "5px" }}>
                      {month}
                    </span>
                    import Jobs
                  </label>
                  <div>
                    <label className="hdrpadding">{values}</label>
                  </div>
                </div>
                <button className="card-footer cardtitle1" onClick={importjob}>
                  import <span>{arrowicon()}</span>
                </button>
              </div>
            </Col>

            <Col className="mt-1">
              <div className="card mb-3 cardclr2" style={{ height: "9rem" }}>
                <div className="card-body ">
                  <label className="dshHeader">
                    <span style={{ fontSize: "15px", marginRight: "5px" }}>
                      {month}
                    </span>
                    export Jobs
                  </label>
                  <div>
                    <label className="hdrpadding">{values2}</label>
                  </div>
                </div>
                <button className="card-footer cardtitle2" onClick={ExportJob}>
                  export <span>{arrowicon()}</span>
                </button>
              </div>
            </Col>

            <Col className="mt-1">
              <div className="card mb-3 cardclr3" style={{ height: "9rem" }}>
                <div className="card-body ">
                  <label className="dshHeader">{month} billed Jobs</label>
                  <div>
                    <label className="hdrpadding">{values3}</label>
                  </div>
                </div>
                <button className="card-footer cardtitle3">
                  Billing <span>{arrowicon()}</span>
                </button>
              </div>
            </Col>

            <Col className="mt-1">
              <div
                className="card mb-3 cardclrimg11"
                style={{ height: "9rem" }}
              >
                <div className="card-body ">
                  <label className="dshHeader">{month} unbilled Jobs</label>
                  <div>
                    <label className="hdrpadding">{values4}</label>
                  </div>
                </div>
                <button className="card-footer cardtitle7">
                  Billing <span>{arrowicon()}</span>
                </button>
              </div>
            </Col>
          </Row>

          <Row style={{ marginBottom: "14%" }}>
            <Col className="mt-3">
              <div className="card mb-3 cardclr4" style={{ height: "9rem" }}>
                <div className="card-body ">
                  <label className="dshHeader">job wise balance Amt</label>
                  <div>
                    <label className="hdrpadding">{amount.totaljobamt}</label>
                  </div>
                </div>
                <button className="card-footer cardtitle4" onClick={exceljob}>
                  Excel sheet-job <span>{arrowicon()}</span>
                </button>
              </div>
            </Col>

            <Col className="mt-3">
              <div className="card mb-3 cardclr5" style={{ height: "9rem" }}>
                <div className="card-body ">
                  <label className="dshHeader">Misc.wise balance Amt</label>
                  <div>
                    <label className="hdrpadding">{amount.totalmiscamt}</label>
                  </div>
                </div>
                <button className="card-footer cardtitle5" onClick={excelmisc}>
                  Excel sheet-Misc <span>{arrowicon()}</span>
                </button>
              </div>
            </Col>

            <Col className="mt-3">
              <div className="card mb-3 cardclr6" style={{ height: "9rem" }}>
                <div className="card-body ">
                  <label className="dshHeader">vendor wise balance Amt</label>
                  <div>
                    <label className="hdrpadding">
                      {amount.totalvendoramt}
                    </label>
                  </div>
                </div>
                <button
                  className="card-footer cardtitle6"
                  onClick={excelvendor}
                >
                  Excel sheet-Vendor <span>{arrowicon()}</span>
                </button>
              </div>
            </Col>

            <Col className="mt-3">
              <div
                className="card mb-3 cardclrimg22"
                style={{ height: "9rem" }}
              >
                <div className="card-body cardclrimg2"></div>
              </div>
            </Col>
          </Row>
        </Row>
      </Grid>
    </div>
  );
}

export default DashBoard;
